import 'bootstrap-slider';
import _slider from './_slider';
import {isTouchDevice} from '../common/_globals';

export default function(){
    _slider.initOnce();
    // Init sliders
    $('.sl-js-number-slider .sl-js-bootstrap-slider').each(function () {
        const itemElementID = $(this).data("item-element-id");
        let values = $(this).data("slider-values");
        const min = $(this).data("slider-min");
        const max = $(this).data("slider-max");
        const step = $(this).data("slider-step");

        if (values === undefined) {
            values = [];
            for (let val = min; val <= max; val += step) {
                values.push(val);
            }
        }
        const slider: JQuery = _slider.bootstrapSlider($(this), [{
            ticks: [min, max]
        }]);
        const sliderElement = _slider.bootstrapSlider(slider, ['getElement']);
        const $sliderHandle = $('.min-slider-handle', sliderElement);
        const $sliderRow = $(sliderElement).closest('.sl-js-item-row');

        // Set current value
        const $inputElement = $('#' + itemElementID, $(this).closest('.sl-slider-column'));
        const hasValue = (<string>$inputElement.val()).length > 0;
        if (hasValue) {
            _slider.bootstrapSlider(slider, ['setValue', $inputElement.val()]);
        } else {
            _slider.hideHandle(slider);
            _slider.bootstrapSlider(slider, ['setValue', min]);
            $(sliderElement).addClass('sl-no-selection');
        }

        if (isTouchDevice()) {
            $(document).on('verticalScrolling', function () {
                if (!_slider.isSliderSliding()) {
                    // When swiping make sure to hide all tooltips
                    $(this).find('.sl-js-number-slider-element .tooltip-main.in').each(function () {
                        $(this).removeClass('in');
                    });
                }
            }).on('touchend', function (e: JQuery.TouchEndEvent) {
                if (_slider.hasSliderFocus()) {
                    resetMarkingOfSliders(e.target);
                }
            });
        }

        slider.on('slideStart', function (event: JQuery.Event) {
            if (isTouchDevice() && _slider.hasSliderFocus()) {
                resetMarkingOfSliders(sliderElement);
            }
            $sliderHandle.trigger('focus');
            if (_slider.isHandleHidden(slider)) {
                // Show the handle and trigger change event
                _slider.showHandle(slider);
                // @ts-ignore Custom bootstrap-slider event with value attribute, no type available
                if (min === event.value) {
                    slider.trigger('change');
                }
            }
            if (isTouchDevice()) {
                // Only mark active rows on touch devices.
                // On desktops this works already fine per default.
                _slider.markActiveSliderRow($sliderRow);
            }
            // Make sure the handle's tooltip is shown
            showTooltip(slider);
            _slider.sliderHasFocus(true);
            _slider.sliderIsSliding(true);
        }).on('change', function () {
            $(sliderElement).removeClass('sl-no-selection');
            const val = _slider.bootstrapSlider(slider, ['getValue']);
            _slider.setValue(slider, val);
        }).on('slideStop', function () {
            _slider.sliderIsSliding(false);
        });
    });

    /**
     * Mark given slider as active. Mark other sliders as inactive and hide their tooltips.
     */
    function resetMarkingOfSliders(activeElement: Element) {
        let hasActiveSliderRow = false;
        $('.sl-js-slider .sl-js-item-row.sl-row-hover').each(function () {
            if ($.contains(this, activeElement)) {
                _slider.markActiveSliderRow($(this));
                hasActiveSliderRow = true;
            } else {
                _slider.unmarkInactiveSliderRow($(this));
            }
        });
        _slider.sliderHasFocus(hasActiveSliderRow);
    }

    function showTooltip(slider: JQuery) {
        $('.tooltip-main:not(.in)', _slider.bootstrapSlider(slider, ['getElement'])).addClass('in');
    }
}